<div class="trailer" *ngIf="trailer && trailer.source">
  <app-small-flags class="trailer-flags" [flags]="trailer.language"></app-small-flags>
  <iframe class="trailer-iframe" [width]="width" [height]="height" [src]="trailerSource" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
</div>
